import { ReactComponent as DollarSignIconSvg } from "app/assets/images/icons/dollar-solid.svg";
import { format } from "date-fns";
import { Subheading } from "elements/Subheading";
import { TotalWithUnit } from "elements/TotalWithUnit";
import React, { memo } from "react";
import { friendlyPaymentMethod } from "utils/friendlyPaymentMethod";

export const BillCostSection: React.FC<{
  bill: Bill;
  paymentStatusDetails: { verb: string; type: string };
}> = memo(({ bill, paymentStatusDetails }) => {
  const invoiceStart = bill
    ? new Date(bill.billing_period.period_started_at)
    : undefined;

  const invoiceEnd = bill
    ? new Date(bill.billing_period.period_ended_at)
    : undefined;

  const invoiceSpansNewYear =
    invoiceStart && invoiceEnd
      ? invoiceStart.getFullYear() !== invoiceEnd.getFullYear()
      : false;

  const invoiceStartFormatted = invoiceStart
    ? format(
        invoiceStart,
        invoiceSpansNewYear ? "EEE d MMMM yyyy" : "EEE d MMMM",
      )
    : undefined;

  const invoiceEndFormatted = invoiceEnd
    ? format(invoiceEnd, "EEE d MMMM yyyy")
    : undefined;

  const paymentDueDate = bill?.payment_due_date
    ? new Date(bill.payment_due_date)
    : undefined;

  return (
    <>
      {invoiceStartFormatted && invoiceEndFormatted && (
        <Subheading
          title={`${invoiceStartFormatted} – ${invoiceEndFormatted}`}
        />
      )}
      {bill?.total_payment_due && (
        <>
          <TotalWithUnit
            total={bill.total_payment_due.price}
            icon={<DollarSignIconSvg />}
          />
          <span className="spacer--small" />
        </>
      )}
      {bill && (
        <p>
          {paymentStatusDetails.verb}{" "}
          {paymentDueDate && format(paymentDueDate, "EEEE d MMMM")}{" "}
          {friendlyPaymentMethod(bill?.payment_method)}
        </p>
      )}
    </>
  );
});
